import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Filter } from '@brafton/angular-framework-library';
import { TextSetDefinition, TextSetDefinitionsService } from '@brafton/text-api-client';

@Component({
  selector: 'shared-filter-panel-definition-id',
  templateUrl: './filter-panel-definition-id.component.html',
  styleUrls: ['./filter-panel-definition-id.component.scss'],
  host: { class: 'definition-id-input' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SharedDefinitionIdInputComponent implements OnInit {
  @Input() definitionId: Filter[] = [];
  @Output() definitionIdChange: EventEmitter<Filter[]> = new EventEmitter<Filter[]>();
  @Output() close: EventEmitter<any> = new EventEmitter();
  textSetDefinitions$?: Observable<any>;

  constructor(private textSetDefinitionsService: TextSetDefinitionsService) {}
  ngOnInit(): void {
    this.textSetDefinitions$ = this.textSetDefinitionsService
      .listTextSetDefinitions(1, 100, '17133016')
      .pipe(map((r) => r.items));
  }

  add(textsetDef: TextSetDefinition) {
    if (!this.definitionId.find((element) => element.value === textsetDef.id)) {
      this.definitionId.push({
        value: textsetDef!.id,
        displayName: textsetDef!.name,
        type: 'definition-id',
      } as Filter);
    }
    this.definitionIdChange.emit(this.definitionId);
  }

  remove(textsetDef: TextSetDefinition) {
    const index = this.definitionId.findIndex((sp) => sp.value === textsetDef.id);
    if (index > -1) {
      this.definitionId.splice(index, 1);
    }
    this.definitionIdChange.emit(this.definitionId);
  }

  isSelected(textsetDef: TextSetDefinition): boolean {
    if (!this.definitionId) return false;
    return !!this.definitionId.find((element) => element.value === textsetDef.id);
  }

  clear() {
    this.definitionId = [];
    this.definitionIdChange.emit(this.definitionId);
  }

  clearText(form: NgForm) {
    form.resetForm();
  }
}
